import { put } from 'redux-saga/effects'
import AuthActions from 'store/redux/auth'
import PhaseActions from 'store/redux/phase'
import PhaseInfoActions from 'store/redux/phaseInfo'
import DATA_PRE_SEASON from 'data/mocks/preSeason.json'
import DATA_PRE_RACE from 'data/mocks/preRace.json'
import DATA_RACE from 'data/mocks/race.json'
import DATA_POST_RACE from 'data/mocks/postRace.json'
import DATA_POST_SEASON from 'data/mocks/postSeason.json'
import { onPhaseUpdated } from './phaseInfo'

export function* cleanData() {
    yield put(PhaseActions.clean())
    yield put(PhaseInfoActions.clean())
}

function* simulatePhase(data) {
    yield* cleanData()
    yield put(AuthActions.setPlayer({ username: 'Adrian', nickname: 'adrianhurt' }))
    yield* onPhaseUpdated({ response: { ok: true, data } })
}

export function* simulatePreSeason() {
    yield* simulatePhase(DATA_PRE_SEASON)
}

export function* simulatePreRace() {
    yield* simulatePhase(DATA_PRE_RACE)
}

export function* simulateRace() {
    yield* simulatePhase(DATA_RACE)
}

export function* simulatePostRace() {
    yield* simulatePhase(DATA_POST_RACE)
}
export function* simulatePostSeason() {
    yield* simulatePhase(DATA_POST_SEASON)
}



// WEBPACK FOOTER //
// src/store/sagas/mocks.js